import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { PageMark } from '@/components/PageMark';

/**
 * The support page, at a public URL — https://fussilat.app/support.
 *
 * Both stores want somewhere a user can get help without signing in, and a
 * reviewer checks that the address on the listing actually reaches somebody.
 * It answers the three questions support actually receives — how to get in,
 * what a guest account is, and how to delete a child's data — so most people
 * never need to write at all.
 */

const CONTACT = 'dr.abdulaziz35@gmail.com';

const FAQ: { q: string; a: string }[] = [
  {
    q: 'لم يصلني رمز الدخول',
    a: 'تأكد من الرقم، وانتظر دقيقة قبل طلب رمز جديد. للرمز صلاحية عشر دقائق، ولخمس محاولات إدخال. إن تكرّر عدم الوصول، راسلنا بالرقم ووقت المحاولة.',
  },
  {
    q: 'ما حساب الضيف؟',
    a: 'يتيح لك استخدام التطبيق كاملاً بلا رقم جوال، لكنه مرتبط بجهازك وحده: تقدّمك وشهاداتك تبقى على هذا الجهاز ولا تنتقل معك. بإضافة رقم جوالك يبقى الحساب نفسه — بكل ما فيه — ويمكنك الدخول به من أي جهاز.',
  },
  {
    q: 'كيف أحذف حساب ابني وبياناته؟',
    a: 'من داخل التطبيق: أبنائي ← اختر الابن ← حذف الحساب. يُحذف معه سجل تلاوته وتسجيلاته وشهاداته. أو راسلنا وننفّذ الطلب.',
  },
  {
    q: 'لماذا لا أرى معلمين متاحين؟',
    a: 'تُعرض جلسات المعلمين المفتوحة الآن فقط. إن لم يظهر أحد فتأكد من تحديد جنسك في ملفك الشخصي لترى المعلمين المتاحين لك.',
  },
  {
    q: 'هل يُسجَّل صوتي؟',
    a: 'صوت الحصة لا يُسجَّل. الكبسولة الصوتية يسجّلها معلمك عمداً لوالدك، ولها مدة احتفاظ محددة تُحذف بعدها تلقائياً. صوت التدريب الذاتي لا يُحفظ أصلاً.',
  },
];

export default function SupportPage() {
  return (
    <main dir="rtl" className="mx-auto w-full max-w-3xl space-y-5 px-4 py-10 text-ink lg:py-14">
      <header className="space-y-3 pb-2">
        <PageMark />
        <h1 className="text-[28px] font-semibold tracking-tight">الدعم — فصّلت</h1>
        <p className="text-helper">تصحيح تلاوة القرآن الكريم مع معلم</p>
      </header>

      <section className="card-soft flex items-start gap-4 p-6">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-lime text-accent-foreground">
          <Mail className="h-5 w-5" strokeWidth={1.8} aria-hidden="true" />
        </span>
        <div className="min-w-0 space-y-1">
          <h2 className="text-lg font-semibold">تواصل معنا</h2>
          <p>
            للأسئلة والمشكلات وطلبات حذف البيانات:{' '}
            <a className="break-all font-medium text-primary underline underline-offset-4" href={`mailto:${CONTACT}`}>{CONTACT}</a>
          </p>
          <p className="text-sm text-helper">نردّ عادةً خلال يومي عمل.</p>
        </div>
      </section>

      <section className="space-y-3">
        <h2 className="pt-2 text-xl font-semibold">أسئلة متكررة</h2>
        {FAQ.map(({ q, a }) => (
          <div key={q} className="card-soft space-y-1.5 p-5">
            <h3 className="font-semibold">{q}</h3>
            <p className="text-[15px] leading-relaxed text-helper">{a}</p>
          </div>
        ))}
      </section>

      <p className="pt-2 text-sm text-helper">
        <Link className="font-medium text-primary underline underline-offset-4" to="/privacy">سياسة الخصوصية</Link>
      </p>
    </main>
  );
}
